import './Results.css'
import { useEffect, useState, useMemo } from 'react'
import {
  Panel
} from '@ui5/webcomponents-react'
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table'
import axios from 'axios'
import { Link, useNavigate } from 'react-router-dom'
import Container from '@mui/material/Container';
import Tooltip from '@mui/material/Tooltip';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTableStyles } from '../utils/tableStyles'
import { useTheme } from '../utils/ThemeContext'
import '../styles/MaterialTableStyles.css';

const STANDINGS_PAGE_SIZE_KEY = 'standings_pageSize';

const Standings = () => {
  const { theme } = useTheme();
  const { panelBackgroundColor, muiTableBodyCellSx, muiTableHeadCellSx, muiTablePaperSx, muiTopToolbarSx, muiBottomToolbarSx } = useTableStyles();
  const navigate = useNavigate();
  //results from backend.  useState in order to share the data across functions/components
  const [standingData, updateStandingData] = useState([])
  const [loading, setLoading] = useState(true)
  const isMobile = useMediaQuery('(max-width:768px)');
  const [showScrollHint, setShowScrollHint] = useState(true);
  const handleTableScroll = (e) => {
    const el = e.currentTarget;
    setShowScrollHint(el.scrollLeft + el.clientWidth < el.scrollWidth - 5);
  };
  // eslint-disable-next-line no-unused-vars
  const [currentYear, setCurrentYear] = useState(process.env.REACT_APP_CURRENT_YEAR)
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: parseInt(sessionStorage.getItem(STANDINGS_PAGE_SIZE_KEY) || '10', 10),
  })

   //get the needed data for the standings and 
   useEffect(() => {
    setLoading(true)
    getData()
  }, [])

  async function getData() {
    await axios.get(`api/public/getStandings.php?year=${process.env.REACT_APP_CURRENT_YEAR}`)
    .then((response) => {
      updateStandingData(response.data.records)
    }).catch((error) =>{
      console.error("Error fetching data: ", error)
    }).finally(() => {
      setLoading(false)
    })
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const columns = useMemo(
    () => [
              {
                header: '',
                accessorKey: 'rank',
                size: 20
              },
              {
                header: 'Name',
                accessorKey: 'name',
                size: 115,
                Cell: ({renderedCellValue, row}) => {
                  return(
                    <>
                      <Tooltip title="View player profile" placement="right" arrow>
                        <Link style={{textDecoration: "none", color: theme.primary, fontWeight: 'bold'}} to={{pathname: '/memberstats', search: `?id=${row.original.playerID}&year=${currentYear}`}}>
                            {renderedCellValue}
                        </Link>
                      </Tooltip>
                    </>
                  )
                }
              },
              {
                header: 'Pts',
                accessorKey: 'points',
                size: 60,
                minSize: 60,
              },
              {
                header: 'Hcp',
                accessorKey: 'hcp',
                size: 60
              },
              {
                header: 'Rounds',
                accessorKey: 'numPlayed',
                size: 85,
                minSize: 85,
              },
              {
                header: 'Avg',
                accessorKey: 'avgScoring',
                size: 70
              },
              {
                header: 'Avg Pts',
                accessorKey: 'avgPoints',
                size: 85,
                minSize: 85,
              },
            ],
            [currentYear, theme],
    );

 const table = useMaterialReactTable({
    columns,
    data: standingData,
    state: { isLoading: loading, pagination },
    onPaginationChange: (updater) => {
      setPagination((prev) => {
        const next = typeof updater === 'function' ? updater(prev) : updater;
        sessionStorage.setItem(STANDINGS_PAGE_SIZE_KEY, String(next.pageSize));
        return next;
      });
    },
    enableColumnPinning: false,
    enableStickyHeader: true,
    enableColumnFilters: false,
    enableHiding: false,
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    enableColumnActions: false,
    initialState: { density: 'compact', columnPinning: { left: ['rank', 'name'] } },
    layoutMode: 'grid',
    muiTableBodyCellProps: {
      sx: muiTableBodyCellSx,
    },
    muiTableHeadCellProps: {
      sx: muiTableHeadCellSx,
    },
    muiTablePaperProps: { sx: muiTablePaperSx },
    muiTopToolbarProps: { sx: muiTopToolbarSx },
    muiBottomToolbarProps: { sx: muiBottomToolbarSx },
    muiTableContainerProps: { onScroll: handleTableScroll },
    muiTableBodyRowProps: ({ row }) => ({
      onClick: () => navigate({ pathname: '/memberstats', search: `?id=${row.original.playerID}&year=${currentYear}` }),
      sx: { cursor: 'pointer' },
    }),
  },[standingData]);

 return(
    <Panel fixed stickyHeader style={{backgroundColor: panelBackgroundColor}} headerText={"Standings"}>
      <Container>
        <div style={{ position: 'relative' }}>
          <MaterialReactTable table={table} />
          {isMobile && showScrollHint && (
            <div style={{
              position: 'absolute', top: 0, right: 0, bottom: 0, width: '48px',
              background: `linear-gradient(to right, transparent, ${theme.panelBgFade})`,
              pointerEvents: 'none', zIndex: 5,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <span style={{ fontSize: '1.2rem', color: theme.primary, opacity: 0.8 }}>›</span>
            </div>
          )}
        </div>
      </Container>
    </Panel>
    )
  }
  
  export default Standings; 